import React from 'react'
import { Box, Typography } from '@mui/material'

import DocumentUpload from '../../../../../assets/icons/DocumentUpload.png'

import DottedBox from './DottedBox'

export default function CSVUploadBox(props: ICSVUploadBox) {
  const {
    onFileUpload,
    handleNext,
    uploadedFilename,
    uploadStatus,
    uploadErr
  } = props

  return (
    <>
      <>
        <DottedBox>
          <>
            <label htmlFor={`upload-preorder`} style={{ cursor: 'pointer' }}>
              <Box
                display='flex'
                flexDirection='column'
                alignItems='center'
                justifyContent='center'
              >
                <img
                  src={DocumentUpload}
                  alt='upload-csv-logo'
                  width='44.67px'
                  height='55.83px'
                />
                <Typography
                  sx={{
                    color: '#A4AAFF',
                    fontSize: '14px',
                    fontWeight: 400,
                    marginRight: '4px'
                  }}
                >
                  Select file for upload
                </Typography>
              </Box>
            </label>
            <input
              id={`upload-preorder`}
              type='file'
              accept='.csv'
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                if (!e.target.files) return
                onFileUpload(e.target.files[0])
                handleNext()
              }}
              hidden
            />
          </>
        </DottedBox>
        <Typography variant='subtitle1' sx={{ color: '#B8C4D3' }}>
          csv, max 8mb
        </Typography>
      </>

      {uploadedFilename && (
        <Typography>
          Uploaded file: <strong>{uploadedFilename}</strong>
        </Typography>
      )}
      <Typography variant='subtitle1' sx={{ color: 'red' }}>
        {uploadStatus === 'ERROR' && uploadErr}
      </Typography>
    </>
  )
}

interface ICSVUploadBox {
  onFileUpload: (any) => void
  handleNext: () => void
  uploadedFilename: string
  uploadStatus: string
  uploadErr: string
}
